import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaURLSearchParamsNode extends ValuableNode {
  @fromSpecific()
  @reactive('deep')
  entries?: string[][]
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.URLSearchParams': SchemaURLSearchParamsNode
  }
}
